(function () {
  const gallery = document.getElementById("product-gallery");
  if (!gallery) return;

  const slides = Array.from(gallery.querySelectorAll("[data-gallery-slide]"));
  const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));
  const prevBtn = gallery.querySelector("[data-gallery-prev]");
  const nextBtn = gallery.querySelector("[data-gallery-next]");
  const counter = gallery.querySelector("[data-gallery-counter]");

  if (!slides.length) return;
  let current = 0;

  function show(index) {
    current = (index + slides.length) % slides.length;

    slides.forEach((slide, i) => {
      slide.classList.toggle("is-active", i === current);
    });

    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle("is-active", i === current);
    });

    if (counter) {
      counter.textContent = `${current + 1} / ${slides.length}`;
    }
  }

  prevBtn?.addEventListener("click", () => show(current - 1));
  nextBtn?.addEventListener("click", () => show(current + 1));

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener("click", () => show(i));
  });

  // Touch / swipe support
  const mainArea = gallery.querySelector("[data-gallery-main]");
  if (mainArea) {
    let touchStartX = 0;
    const SWIPE_THRESHOLD = 50;

    mainArea.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    mainArea.addEventListener("touchend", (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > SWIPE_THRESHOLD) {
        show(diff > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });
  }

  show(0);
})();
